import UserAgentCapabilitiesActions from "../react_actions/user_agent_capabilities_actions";

export default {
  UserAgentCapabilitiesActions,
};
